import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@teko/ds-desktop';

var messengerFull = "https://shopfront-cdn.tekoapis.com/static/9a8ee78019793075.png";

var messenger = "https://shopfront-cdn.tekoapis.com/static/0ac367e87cf9380a.png";

const Wrapper = styled.a `
  z-index: 1030;
  position: fixed;
  right: 2.5rem;
  bottom: 2rem;
  cursor: pointer;
  @media (min-width: 1440px) {
    .zalo-chat-full {
      bottom: 1.5rem;
      display: block;
    }
    .zalo-chat {
      display: none;
    }
  }
  @media (max-width: 1440px) {
    .zalo-chat-full {
      display: none;
    }
    .zalo-chat {
      display: block;
    }
  }
  @media print {
    display: none;
  }
`;
const Zalo = ({ url }) => {
    return (jsxs(Wrapper, Object.assign({ href: url, target: "_blank", rel: "noreferrer", "data-track-content": true, "data-content-region-name": "quickAction", "data-content-name": "zaloMessengerIcon" }, { children: [jsx("img", { className: "zalo-chat-full", src: messengerFull, alt: "zalo-chat" }, void 0), jsx("img", { className: "zalo-chat", src: messenger, alt: "zalo-chat" }, void 0)] }), void 0));
};

export { Zalo as Z };
